import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { TasksService } from 'src/app/services/tasks.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-skill-create',
  template: `
    <div class="row">
      <div class="col-sm-12 offset-sm-0 col-lg-9 offset-lg-3 mt-5">
      <xng-breadcrumb ></xng-breadcrumb>
        <div class="row mb-4 mt-4">
          <div class="col-md-9">
            <h1>Habilidad</h1>
            <p>Configura las habilidades que están disponibles para los técnicos.</p>
          </div>
          <div class="col-md-3 text-end mt-4">
            
          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="card border-0 rounded-4 shadow">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-md-12">
                    <h4>Agregar habilidad</h4>
                    <p>Configura la habilidad con los siguientes campos.</p>
                    <app-form-skill (skillData)="createSkill($event)" [profile]="profile" [loading]="loading"></app-form-skill>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class SkillCreateComponent implements OnInit {
  loading: boolean = false;
  profile: any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE) ?? '{}');

  constructor(
    private store: SettlementsService,
    private tasks: TasksService,
    private toastr: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.breadcrumbService.set('@skillCreate', 'Crear habilidad');
  }

  createSkill(event: any) {
    this.tasks.createSkill(event).subscribe({
      next: (data: any) => {
        console.log(data);
        this.toastr.success('Habilidad creado correctamente.');
        this.router.navigate(['/inventory/skills']);
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al crear la habilidad.');
      }
    });
  }
}
